import * as React from 'react';
import { Badge } from '@/hen-ui/atomics/Badge';
import { Flex } from '../../../Flex';
import { Icon } from '@/hen-ui/atomics/Icon';
import { Text } from '@/hen-ui/atomics/Text';
import type { DualTextCellValue } from '../../types';
import { COMPARISON_STRIKE_COLOR } from '../../utils/contrast';

interface DualTextCellProps {
  value?: DualTextCellValue;
}

export const DualTextCell: React.FC<DualTextCellProps> = ({ value }) => {
  const hasContent =
    value?.primary || value?.strike || value?.badge || value?.icon;

  if (!hasContent || !value) {
    console.error(
      '[DualTextCell] No content provided. DualTextCell requires at least one primary, strike, badge, or icon.',
    );
    return null;
  }

  return (
    <Flex direction='row' align='center' gap='xs' wrap='wrap'>
      {value.icon && <Icon icon={value.icon} size='sm' aria-hidden />}
      {value.strike && (
        <Text
          variant='b4'
          weight='bold'
          className='line-through'
          tag='del'
          style={{ color: COMPARISON_STRIKE_COLOR }}
        >
          {value.strike}
        </Text>
      )}
      {value.primary && (
        <Text variant='b4' tag='span' color='subtext' weight='bold'>
          {value.primary}
        </Text>
      )}
      {value.badge && (
        <Badge variant={value.badge.variant} size={value.badge.size ?? 'sm'}>
          {value.badge.icon && (
            <Icon icon={value.badge.icon} size='sm' aria-hidden />
          )}
          {value.badge.text}
        </Badge>
      )}
    </Flex>
  );
};

DualTextCell.displayName = 'DualTextCell';
